import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "@/constants/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee-mask overflow-hidden border-y border-slate-200 bg-white py-5" data-testid="trust-marquee">
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-mono text-xs font-bold uppercase tracking-[0.25em] text-slate-400 sm:text-sm">
              {item}
            </span>
            <Asterisk className="mx-8 h-5 w-5 shrink-0 text-rescue" />
          </span>
        ))}
      </div>
    </div>
  );
}
